<template>
  <div>
    <div class="row mt-2 mb-3 mx-md-3">
      <div class="offset-lg-2 col-md-8 my-3">
        <div class="bg-white px-3 pt-3 pb-1 mb-3 h-100">
          <h6 class="text-orange mb-0">Top Up</h6>

          Coming soon...

          <!-- <div class="row">
            <div class="col-lg-5">
              <div
                class="px-3 py-2 my-4"
                style="background: #E5E5E5;border: 1px solid #C4C4C4;box-sizing: border-box;border-radius: 10px;"
              >
                <p class="font-14 mb-0 text-dark">Current Loan Amount</p>
                <h3 class="mb-0 text-orange">NGN 500,000</h3>
              </div>

              <div
                class="px-3 py-2 my-4"
                style="background: #E5E5E5;border: 1px solid #C4C4C4;box-sizing: border-box;border-radius: 10px;"
              >
                <p class="font-14 mb-0 text-dark">Date Due</p>
                <h4 class="mb-0 text-dark">12 - 3 - 2020</h4>
              </div>
            </div>
          </div>

          <form class="get-loan">
            <div class="form-row">
              <div class="form-group col-lg-5">
                <label class="mb-1 font-13" for="additional_payment"
                  >Add Additional Amount</label
                >
                <input
                  id="additional_payment"
                  type="text"
                  class="form-control"
                  placeholder="New Amount"
                />
              </div>
            </div>

            <div class="form-row">
              <div class="form-group col-lg-5">
                <label class="mb-1 font-13" for="loan_tenure"
                  >Loan Tenure</label
                >
                <select
                  name="loan_tenure"
                  class="custom-select"
                  v-model="topop.loan_tenure"
                  :class="{
                    'is-invalid': topop.errors.has('loan_tenure')
                  }"
                >
                  <option selected value=""> -- select --</option>
                  <option
                    v-for="tenure in loan_parameters.employee_loan_tenure"
                    :key="tenure.id"
                    :value="tenure.title"
                    >{{ tenure.title + " months" }}</option
                  >
                </select>
                <has-error :form="topop" field="loan_tenure" />
              </div>
            </div>

            <div class="d-flex my-4">
              <div class="col px-lg-0">
                <a
                  @click.prevent="$router.go(-1)"
                  href="#"
                  class="btn btn-back px-5"
                  >Back</a
                >
              </div>
              <div class="col text-right px-lg-0">
                <button
                  type="button"
                  class="btn btn-next px-5"
                  data-toggle="modal"
                  data-target="#topup_success_modal"
                >
                  Next
                </button>
              </div>
            </div>
          </form> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Form } from "vform";
// import { toggleFormLoading } from "@/Helpers/general";
// import axios from "axios";

export default {
  name: "top-up",
  layout: "app",
  middleware: "auth",
  computed: {
    ...mapGetters({
      loan: "loan/loan"
    })
  },
  data: () => ({
    loan_parameters: {
      employee_loan_tenure: []
    },
    topop: new Form({})
  }),
  methods: {},
  mounted() {
    this.loan_parameters.employee_loan_tenure = this.loan.loan_tenure;
  }
};
</script>

<style scoped></style>
